import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d43821c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-4 full-width-text" }
const _hoisted_2 = {
  class: "mb-4 full-width-text",
  style: {"margin-top":"5px"}
}
const _hoisted_3 = {
  class: "mb-4 full-width-text",
  style: {"text-align":"right!important"}
}


import { ref, defineComponent, defineProps, onMounted } from 'vue'
import { getLanguage, apiFetchData, apiPostData, isEmptyString, isEmptyArray } from '../utils'
import { getDescriptionUrl, saveSescriptionUrl } from '../config'
import store from '../store'

// 解决vs中的语法错误提示
const __default__ = defineComponent({
  name: 'PageDescription'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  id: {
    type: String,
    require: true
  }
},
  setup(__props) {

const refIsEdit = ref(false)
const refZhContent = ref('')
const refEnContent = ref('')
const refLanguage = ref('zh')

const props = __props

const refIsAdmin = ref(false)
onMounted(async () => {
  refIsAdmin.value = store.state.isAdmin
  refLanguage.value = getLanguage()
  const url = `${getDescriptionUrl}&contentKey=${props.id}`
  const data = await apiFetchData(url)

  if (isEmptyArray(data.data) || isEmptyString(data.data[0].zh_content)) {
    refZhContent.value = '请输入说明内容，管理员双击编辑'
  } else {
    refZhContent.value = data.data[0].zh_content
  }
  if (isEmptyArray(data.data) || isEmptyString(data.data[0].en_content)) {
    refEnContent.value = 'please input description. administrator double click to edit'
  } else {
    refEnContent.value = data.data[0].en_content
  }
})

const showContent = () => {
  if (refLanguage.value === 'zh') {
    return refZhContent.value
  } else {
    if ((refEnContent.value.startsWith('please input') || isEmptyString(refEnContent.value)) && !refZhContent.value.startsWith('请输入')) {
      return refZhContent.value
    } else {
      return refEnContent.value
    }
  }
}
const onDblClick = () => {
  refIsEdit.value = !refIsEdit.value
}
const save = () => {
  // refIsEdit.value = false
  const url = `${saveSescriptionUrl}`
  console.log('save')
  const data = { contentKey: props.id, zhContent: refZhContent.value, enContent: refEnContent.value }
  apiPostData(url, data)
    .then(data => {
      if (isEmptyArray(data)) {
        console.log('deleteDatsavea data=', data)
      }
    })
}
const close = () => {
  save()
  refIsEdit.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_divider),
    _createElementVNode("div", {
      class: "home",
      onDblclick: onDblClick
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((showContent()).split('\n'), (line) => {
        return (_openBlock(), _createElementBlock("p", {
          class: "mx-1 full-width-text",
          key: line
        }, _toDisplayString(line), 1))
      }), 128))
    ], 32),
    _createVNode(_component_el_divider),
    (refIsEdit.value && refIsAdmin.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_text, { class: "mx-1 full-width-text" }, {
              default: _withCtx(() => [
                _createTextVNode("中文描述")
              ]),
              _: 1
            }),
            _createVNode(_component_el_input, {
              modelValue: refZhContent.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refZhContent).value = $event)),
              autosize: { minRows: 2, maxRows: 10 },
              type: "textarea",
              placeholder: "Please input"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_text, { class: "mx-1 full-width-text" }, {
              default: _withCtx(() => [
                _createTextVNode("英文描述")
              ]),
              _: 1
            }),
            _createVNode(_component_el_input, {
              modelValue: refEnContent.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refEnContent).value = $event)),
              autosize: { minRows: 2, maxRows: 10 },
              type: "textarea",
              placeholder: "Please input"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: save
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: close
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})